$(document).ready(function () {

    var $wrapper = $('.site-version-container');
    
    if ($wrapper.length < 1)
        return;

    if ($('html').hasClass("touch")) {
        $('.to-desktop', $wrapper).addClass("visible");
    } else {
        $('.to-mobile', $wrapper).addClass("visible");
    }

    $('.version-button').click(function () {
        if ($('html').hasClass("touch")) {
            Cookies.set("siteVersion", "Desktop", { expires: 365, samesite: 'Lax' });
        } else {
            Cookies.set("siteVersion", "Mobile", { expires: 365, samesite: 'Lax' });
        }
        window.location.href = window.location.href;
    });

});
